import BCPProcessAreas from './BCPprocessAreas'
export default BCPProcessAreas